import {
    SET_SHOW_HIGHER_ORDER_SEQUENCER,
    SET_HIGHER_ORDER_MATRIX,
    SET_HIGHER_ORDER_STEPS_SELECTED,
    SET_MODULE_COLOR,
    SET_MODULES_ROUTING,
    SET_ORIENTATION_ROUTINGS
    } from 'constants/action-types.js';

let initialState = {
    show: false,
    matrix: new Array(16).fill(new Array(10).fill(0)),
    colors: {},
    inputModules: [],
    outputModules: [],
    orientationRoutings: {},
    selectedSteps: undefined
};

const higherOrderReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_SHOW_HIGHER_ORDER_SEQUENCER:
        return {
            ... state,
            show: action.payload
        };
    case SET_ORIENTATION_ROUTINGS:
        return {
            ... state,
            orientationRoutings: action.payload
        };
    case SET_HIGHER_ORDER_STEPS_SELECTED:
        return {
            ... state,
            selectedSteps: action.payload
        };
    case SET_MODULES_ROUTING:
        return {
            ... state,
            inputModules: action.payload.inputModules,
            outputModules: action.payload.outputModules
        };
    case SET_HIGHER_ORDER_MATRIX:
        return {
            ...state,
            matrix: action.payload
        };
    case SET_MODULE_COLOR:
        let colors = {... state.colors};
        colors[action.payload.id] = action.payload.color;
        return {
            ... state,
            colors
        };
    default:
        return state;
    }
};

export default higherOrderReducer;
